<template>
	<div class="pc-home-page">
		<div class="pc-home-page-wrapper">
			<div class="pc-home-page">
				<div class="pc-home-content">
					<!-- 轮播图模块 -->
					<div :class="moduleIndex == 0 ? 'pc-home-banner pc-home-module-on' : 'pc-home-banner'" @click="selectModule(0)">
						<el-carousel :height="carouselHeight" indicator-position="outside" v-if="data[0] && data[0].length > 0">
							<el-carousel-item v-for="(item, index) in data[0]" :key="index">
								<el-image fit="cover" style="width: 100%;height: 100%" :src="$img(item.image)" />
							</el-carousel-item>
						</el-carousel>
						<div v-else class="pc-home-empty-banner">
							<i class="el-icon-picture"></i>
							<div>暂无轮播图数据</div>
						</div>
						<div class="pc-home-jianyi">建议尺寸1920px × 760px</div>
					</div>

					<!-- 产品分类模块 -->
					<div class="pc-home-classify" :class="moduleIndex == 1 ? 'pc-home-classify pc-home-module-on' : 'pc-home-classify'"
						@click="selectModule(1)">
						<div class="pc-home-classify-title">
							探索我们的产品
						</div>
						<div class="pc-home-classify-label">
							户外保险找安心保
						</div>
						<div class="pc-home-classify-list">
							<template v-if="data[1] && data[1].length > 0">
								<div class="pc-home-classify-item" v-for="(item, index) in data[1]" :key="index">
									<div class="pc-home-classify-info">
										<div class="pc-home-classify-icon">
											<el-image fit="cover" style="width: 10px;height: 10px"
												:src="$img(item.image)" />
										</div>
										<div class="pc-home-classify-name">
											{{ item.title || '未设置标题' }}
										</div>
									</div>
									<div class="pc-home-classify-item-more">
										<i class="el-icon-arrow-right"></i>
									</div>
								</div>
							</template>
							<div v-else class="pc-home-empty-classify">
								<i class="el-icon-menu"></i>
								<div>暂无分类数据</div>
							</div>
						</div>
					</div>

					<!-- 关于我们模块 -->
					<div :class="moduleIndex == 2 ? 'pc-home-about pc-home-module-on' : 'pc-home-about'" @click="selectModule(2)">
						<div class="pc-home-about-title">
							关于安心保
						</div>
						<div class="pc-home-about-label">
							安心保您的户外保险小助手
						</div>

						<div class="pc-home-about-info" v-if="data[2] && data[2][0]">
							<div class="pc-home-about-image">
								<el-image fit="cover" :src="$img(data[2][0].image)" />
								<div class="pc-home-jianyi">建议尺寸700px × 400px</div>
							</div>
							<div class="pc-home-about-content">
								<div class="pc-home-about-info-title">
									{{ data[2][0].title || '关于我们' }}
								</div>
								<div class="pc-home-about-info-content">
									{{ data[2][0].content || '暂无内容介绍' }}
								</div>
							</div>
						</div>
						<div class="pc-home-about-info" v-else>
							<div class="pc-home-about-image">
								<div class="pc-home-empty-image">
									<i class="el-icon-picture"></i>
									<div>暂无图片</div>
								</div>
							</div>
							<div class="pc-home-about-content">
								<div class="pc-home-about-info-title">关于我们</div>
								<div class="pc-home-about-info-content">暂无内容介绍</div>
							</div>
						</div>
					</div>

					<!-- 合作伙伴模块 -->
					<div :class="moduleIndex == 3 ? 'pc-home-cooperation pc-home-module-on' : 'pc-home-cooperation'"
						@click="selectModule(3)">
						<div class="pc-home-cooperation-title">
							合作伙伴
						</div>
						<div class="pc-home-cooperation-label">
							安心保期待与您的合作
						</div>
						<div class="pc-home-cooperation-list">
							<template v-if="data[3] && data[3].length > 0">
								<div class="pc-home-cooperation-item" v-for="(item, index) in data[3]" :key="index">
									<el-image fit="contain" :src="$img(item.image)" />
								</div>
							</template>
							<div v-else class="pc-home-empty-cooperation">
								<i class="el-icon-office-building"></i>
								<div>暂无合作伙伴</div>
							</div>
						</div>
					</div>
				</div>

				<!-- 编辑器区域 -->
				<div class="pc-home-editor-panel">
					<div class="pc-home-editor-header">
						<div class="pc-home-header-title">模块编辑</div>
						<el-button type="primary" @click="save(data)" :loading="saving"
							class="pc-home-save-btn">
							<i class="el-icon-check"></i>
							保存修改
						</el-button>
					</div>

					<div class="pc-home-editor-body">
						<div class="pc-home-editor-content-wrapper">
							<div class="pc-home-editor-content">
								<!-- 模块列表 -->
								<div class="pc-home-module-list" v-if="moduleIndex === -1">
									<div class="pc-home-module-item" v-for="(item, index) in moduleTypes" :key="index"
										@click="selectModule(index)">
										<div class="pc-home-module-icon">
											<i :class="moduleIcons[index]"></i>
										</div>
										<div class="pc-home-module-name">{{ item.name }}</div>
									</div>
								</div>

								<!-- 项目列表 -->
								<div class="pc-home-item-list" v-else>
									<div class="pc-home-current-module">
										<div class="pc-home-module-info">
											<i :class="moduleIcons[moduleIndex]"></i>
											<span>当前编辑：{{ moduleTypes[moduleIndex].name }}</span>
										</div>
										<el-button size="mini" @click="moduleIndex = -1" class="pc-home-back-btn">
											<i class="el-icon-back"></i>
											返回
										</el-button>
									</div>

									<div class="pc-home-item" v-for="(item, index) in data[moduleIndex]" :key="index">
										<div class="pc-home-item-header">
											<span class="pc-home-item-index">
												<i class="el-icon-document"></i>
												项目 {{ index + 1 }}
											</span>
											<div class="pc-home-item-actions" v-if="moduleIndex != 2">
												<el-tooltip content="上移" placement="top">
													<el-button size="mini" icon="el-icon-top"
														@click.stop="moveUp(moduleIndex,index)"
														:disabled="index === 0"></el-button>
												</el-tooltip>
												<el-tooltip content="下移" placement="top">
													<el-button size="mini" icon="el-icon-bottom"
														@click.stop="moveDown(moduleIndex,index)"
														:disabled="index === data[moduleIndex].length - 1"></el-button>
												</el-tooltip>
												<el-tooltip content="删除" placement="top">
													<el-button size="mini" icon="el-icon-delete" type="danger"
														@click.stop="delModule(moduleIndex,index)"></el-button>
												</el-tooltip>
											</div>
										</div>

										<div class="pc-home-item-content">
											<div class="pc-home-item-image">
												<div class="pc-home-image-label">
													<i class="el-icon-picture"></i>
													图片
												</div>
												<page-images @change="change" v-model="item.image" :limit="1" />
											</div>

											<div class="pc-home-item-form">
												<el-form size="small" label-width="70px">
													<el-form-item label="标题">
														<el-input v-model="item.title" @input="change"
															placeholder="请输入标题" prefix-icon="el-icon-edit" />
													</el-form-item>
													<el-form-item label="链接" v-if="moduleIndex != 2">
														<el-input v-model="item.url" @input="change"
															placeholder="请输入链接地址" prefix-icon="el-icon-link" />
													</el-form-item>
													<el-form-item label="内容" v-if="moduleIndex == 2">
														<el-input @input="change" show-word-limit v-model="item.content"
															type="textarea" :autosize="{ minRows: 4, maxRows: 8}"
															:maxlength="1000" placeholder="请输入内容" />
													</el-form-item>
												</el-form>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="pc-home-editor-footer" v-if="moduleIndex > -1 && moduleIndex != 2">
							<div class="pc-home-add-btn" @click="addModule">
								<i class="el-icon-plus"></i>
								<span>添加项目</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'HomePC',
		data() {
			return {
				moduleIndex: -1,
				data: [
					[], // 轮播图
					[], // 产品分类
					[{ image: '', title: '', content: '' }], // 关于我们 - 确保至少有一个对象
					[] // 合作伙伴
				],
				carouselHeight: '300px',
				saving: false,
				moduleTypes: [
					{ name: '轮播图' },
					{ name: '产品分类' },
					{ name: '关于我们' },
					{ name: '合作伙伴' }
				],
				moduleIcons: [
					'el-icon-picture-outline',
					'el-icon-menu',
					'el-icon-info',
					'el-icon-office-building'
				]
			}
		},
		async mounted() {
			await this.initializeComponent();
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.updateDimensions);
		},
		methods: {
			async initializeComponent() {
				// 设置基础布局
				this.updateDimensions();
				
				// 加载数据
				await this.getPageData();
				
				// 添加事件监听
				window.addEventListener('resize', this.updateDimensions);
			},
			
			updateDimensions() {
				const width = window.innerWidth;
				if (width < 1366) {
					this.carouselHeight = '250px';
				} else if (width < 1024) {
					this.carouselHeight = '200px';
				} else {
					this.carouselHeight = '300px';
				}
			},
			
			async save(data) {
				this.saving = true;
				try {
					await this.$put('app-page-design/2', {
						content: JSON.stringify(data)
					});
					this.$message.success('保存成功');
				} catch (err) {
					this.$message.error(err || '保存失败');
				} finally {
					this.saving = false;
				}
			},
			
			moveUp(moduleIndex, index) {
				if (index === 0) return;
				// 使用 $set 确保 Vue 能检测到数组变化
				const temp = this.data[moduleIndex][index - 1];
				this.$set(this.data[moduleIndex], index - 1, this.data[moduleIndex][index]);
				this.$set(this.data[moduleIndex], index, temp);
			},
			
			moveDown(moduleIndex, index) {
				if (index === this.data[moduleIndex].length - 1) return;
				// 使用 $set 确保 Vue 能检测到数组变化
				const temp = this.data[moduleIndex][index + 1];
				this.$set(this.data[moduleIndex], index + 1, this.data[moduleIndex][index]);
				this.$set(this.data[moduleIndex], index, temp);
			},
			
			delModule(moduleIndex, index) {
				this.$confirm('确定删除该项目吗？', '提示', {
					type: 'warning'
				}).then(() => {
					// 使用 splice 删除，Vue 能检测到变化
					this.data[moduleIndex].splice(index, 1);
					this.$message.success('删除成功');
				});
			},
			
			change() {
				// 输入变化时的处理
			},
			
			addModule() {
				if (!this.data[this.moduleIndex]) {
					this.$set(this.data, this.moduleIndex, []);
				}
				// 使用 push 方法添加新项目
				this.data[this.moduleIndex].push({
					image: '',
					title: '',
					url: '',
					content: '',
				});
				this.$message.success('添加项目成功');
			},
			
			selectModule(index) {
				this.moduleIndex = index;
			},
			
			async getPageData() {
				try {
					const res = await this.$get('app-page-design/2');
					
					if (res.data && res.data.content) {
						let content;
						try {
							content = typeof res.data.content === 'string' 
								? JSON.parse(res.data.content) 
								: res.data.content;
						} catch (e) {
							console.warn('数据解析失败，使用默认数据:', e);
							content = [];
						}
						
						this.data = this.validateDataStructure(content);
					}
				} catch (err) {
					console.warn('数据请求失败，使用默认数据:', err);
				}
			},
			
			validateDataStructure(content) {
				const validated = [];
				for (let i = 0; i < 4; i++) {
					if (content && content[i] && Array.isArray(content[i]) && content[i].length > 0) {
						validated[i] = content[i];
					} else {
						// 确保关于我们模块至少有一个空对象
						validated[i] = i === 2 ? [{ image: '', title: '', content: '' }] : [];
					}
				}
				return validated;
			},
		},
	}
</script>

<style lang="scss" scoped>
.pc-home-page {
	width: 100%;
	height: 100%;
	position: relative;
	visibility: visible !important;
	opacity: 1 !important;
	background: #f5f7fa;
	
	.pc-home-page-wrapper {
		width: 100%;
		height: 100%;
		position: relative;
		display: block !important;

		.pc-home-page {
			display: flex !important;
			height: 100%;
			gap: 24px;
			padding: 24px;
			box-sizing: border-box;
			position: relative;
			flex-direction: row !important;

			.pc-home-content {
				flex: 1;
				background: white;
				border-radius: 16px;
				box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
				overflow-y: auto;
				padding: 32px;
				min-height: 0;
				border: 1px solid #e8e8e8;

				.pc-home-banner {
					width: 100%;
					background: #ffffff;
					border-radius: 12px;
					overflow: hidden;
					margin-bottom: 24px;
					cursor: pointer;
					transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
					border: 1px solid rgba(91, 140, 255, 0.1);

					&:hover {
						box-shadow: 0 12px 40px rgba(91, 140, 255, 0.15);
						transform: translateY(-2px);
					}

					&.pc-home-module-on {
						border: 2px dashed #5B8CFF;
						box-shadow: 0 0 0 4px rgba(91, 140, 255, 0.1);
					}

					.pc-home-jianyi {
						text-align: center;
						color: #909399;
						margin-top: 8px;
						font-size: 12px;
						font-weight: 500;
					}
				}

				.pc-home-classify {
					padding: 48px 12%;
					background: #ffffff;
					border-radius: 12px;
					margin-bottom: 24px;
					cursor: pointer;
					transition: all 0.4s ease;
					border: 1px solid rgba(91, 140, 255, 0.1);
					position: relative;
					overflow: hidden;

					&:hover {
						box-shadow: 0 12px 40px rgba(91, 140, 255, 0.15);
						transform: translateY(-2px);
					}

					&.pc-home-module-on {
						border: 2px dashed #5B8CFF;
						box-shadow: 0 0 0 4px rgba(91, 140, 255, 0.1);
					}

					.pc-home-classify-title {
						text-align: center;
						color: #303133;
						font-size: 20px;
						font-weight: 700;
						letter-spacing: 0.5px;
						margin-bottom: 8px;
					}

					.pc-home-classify-label {
						text-align: center;
						color: #606266;
						font-size: 13px;
						margin-bottom: 24px;
						font-weight: 500;
					}

					.pc-home-classify-list {
						width: 100%;
						gap: 10px;
						display: flex;
						flex-wrap: wrap;
						margin-top: 24px;

						.pc-home-classify-item {
							display: flex;
							align-items: center;
							background: #ffffff;
							border: 1px solid #5B8CFF;
							padding: 10px 14px;
							border-radius: 10px;
							width: calc(25% - 10px);
							cursor: pointer;
							justify-content: space-between;
							box-sizing: border-box;
							transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
							position: relative;
							overflow: hidden;

							&::before {
								content: '';
								position: absolute;
								top: 0;
								left: -100%;
								width: 100%;
								height: 100%;
								background: linear-gradient(90deg, transparent, rgba(91, 140, 255, 0.1), transparent);
								transition: left 0.6s;
							}

							&:hover {
								background: #5B8CFF;
								transform: translateY(-2px);
								box-shadow: 0 6px 20px rgba(91, 140, 255, 0.25);

								&::before {
									left: 100%;
								}

								.pc-home-classify-name {
									color: white;
								}

								.pc-home-classify-icon {
									background: rgba(255, 255, 255, 0.2);
								}

								.pc-home-classify-item-more {
									background: rgba(255, 255, 255, 0.2);
									
									i {
										color: white;
									}
								}
							}

							.pc-home-classify-info {
								display: flex;
								align-items: center;

								.pc-home-classify-icon {
									width: 18px;
									height: 18px;
									display: flex;
									justify-content: center;
									align-items: center;
									background-color: #f1faff;
									border-radius: 50%;
									transition: all 0.3s ease;
									
									::v-deep .el-image {
										width: 8px;
										height: 8px;
									}
								}

								.pc-home-classify-name {
									color: #303133;
									font-size: 11px;
									margin-left: 6px;
									font-weight: 600;
									white-space: nowrap;
									overflow: hidden;
									text-overflow: ellipsis;
									max-width: 80px;
									transition: color 0.3s ease;
								}
							}

							.pc-home-classify-item-more {
								width: 18px;
								height: 18px;
								display: flex;
								justify-content: center;
								align-items: center;
								background-color: #f1faff;
								border-radius: 50%;
								transition: all 0.3s ease;

								i {
									font-size: 10px;
									color: #2280fd;
									font-weight: bold;
								}
							}
						}
					}
				}

				.pc-home-about {
					background: #ffffff;
					padding: 36px 48px 24px;
					border-radius: 12px;
					margin-bottom: 24px;
					cursor: pointer;
					transition: all 0.4s ease;
					border: 1px solid rgba(91, 140, 255, 0.1);
					position: relative;

					&:hover {
						box-shadow: 0 12px 40px rgba(91, 140, 255, 0.15);
						transform: translateY(-2px);
					}

					&.pc-home-module-on {
						border: 2px dashed #5B8CFF;
						box-shadow: 0 0 0 4px rgba(91, 140, 255, 0.1);
					}

					.pc-home-about-title {
						text-align: center;
						color: #303133;
						font-size: 20px;
						font-weight: 700;
						letter-spacing: 0.5px;
						margin-bottom: 8px;
					}

					.pc-home-about-label {
						text-align: center;
						font-size: 13px;
						color: #606266;
						margin-bottom: 24px;
						font-weight: 500;
					}

					.pc-home-about-info {
						display: flex;
						align-items: flex-start;
						margin-top: 20px;
						gap: 30px;
						max-height: 350px;
						overflow: hidden;

						.pc-home-about-image {
							flex-shrink: 0;
							width: 300px;
							
							::v-deep .el-image {
								width: 100%;
								height: 180px;
								border-radius: 12px;
								box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
								transition: all 0.3s ease;
								
								&:hover {
									transform: scale(1.02);
								}
							}
							
							.pc-home-jianyi {
								text-align: center;
								color: #909399;
								margin-top: 8px;
								font-size: 11px;
								font-weight: 500;
							}
						}

						.pc-home-about-content {
							flex: 1;
							display: flex;
							flex-direction: column;
							height: 100%;
							min-height: 180px;

							.pc-home-about-info-title {
								color: #303133;
								font-size: 16px;
								font-weight: 700;
								margin-bottom: 12px;
								position: relative;
								line-height: 1.4;
								
								&::after {
									content: '';
									position: absolute;
									bottom: -4px;
									left: 0;
									width: 30px;
									height: 2px;
									background: #5B8CFF;
									border-radius: 2px;
								}
							}

							.pc-home-about-info-content {
								color: #606266;
								font-size: 13px;
								line-height: 1.6;
								font-weight: 400;
								flex: 1;
								overflow-y: auto;
								max-height: 140px;
								padding-right: 8px;
								margin-bottom: 8px;
								
								/* 滚动条样式 */
								&::-webkit-scrollbar {
									width: 4px;
								}
								
								&::-webkit-scrollbar-track {
									background: #f1f1f1;
									border-radius: 2px;
								}
								
								&::-webkit-scrollbar-thumb {
									background: #c1c1c1;
									border-radius: 2px;
								}
								
								&::-webkit-scrollbar-thumb:hover {
									background: #a8a8a8;
								}
							}
						}
					}
				}

				.pc-home-cooperation {
					padding: 36px 12%;
					background: #ffffff;
					border-radius: 12px;
					cursor: pointer;
					transition: all 0.4s ease;
					border: 1px solid rgba(91, 140, 255, 0.1);
					position: relative;

					&:hover {
						box-shadow: 0 12px 40px rgba(91, 140, 255, 0.15);
						transform: translateY(-2px);
					}

					&.pc-home-module-on {
						border: 2px dashed #5B8CFF;
						box-shadow: 0 0 0 4px rgba(91, 140, 255, 0.1);
					}

					.pc-home-cooperation-title {
						text-align: center;
						color: #303133;
						font-size: 20px;
						font-weight: 700;
						letter-spacing: 0.5px;
						margin-bottom: 8px;
					}

					.pc-home-cooperation-label {
						text-align: center;
						font-size: 13px;
						color: #606266;
						margin-bottom: 24px;
						font-weight: 500;
					}

					.pc-home-cooperation-list {
						width: 100%;
						gap: 16px;
						display: flex;
						flex-wrap: wrap;
						margin-top: 24px;

						.pc-home-cooperation-item {
							background: #ffffff;
							border-radius: 10px;
							width: calc(25% - 12px);
							cursor: pointer;
							display: flex;
							justify-content: center;
							align-items: center;
							padding: 16px;
							box-sizing: border-box;
							border: 1px solid rgba(91, 140, 255, 0.2);
							transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
							position: relative;
							overflow: hidden;

							&::before {
								content: '';
								position: absolute;
								top: 0;
								left: 0;
								right: 0;
								bottom: 0;
								background: rgba(91, 140, 255, 0.05);
								opacity: 0;
								transition: opacity 0.3s ease;
							}

							&:hover {
								transform: translateY(-3px);
								box-shadow: 0 10px 28px rgba(91, 140, 255, 0.2);
								border-color: #5B8CFF;

								&::before {
									opacity: 1;
								}
							}

							::v-deep .el-image {
								width: 80%;
								height: 50px;
								object-fit: contain;
								position: relative;
								z-index: 1;
								filter: grayscale(0.3);
								transition: filter 0.3s ease;
								
								&:hover {
									filter: grayscale(0);
								}
							}
						}
					}
				}
			}

			.pc-home-editor-panel {
				width: 420px;
				background: white;
				border-radius: 16px;
				box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
				display: flex;
				flex-direction: column;
				min-height: 0;
				border: 1px solid #e8e8e8;

				.pc-home-editor-header {
					padding: 20px 24px;
					border-bottom: 1px solid rgba(91, 140, 255, 0.1);
					display: flex;
					justify-content: space-between;
					align-items: center;
					flex-shrink: 0;
					background: #5B8CFF;
					border-radius: 16px 16px 0 0;
					
					.pc-home-header-title {
						font-size: 18px;
						font-weight: 700;
						color: white;
						letter-spacing: 0.5px;
					}

					.pc-home-save-btn {
						height: 36px;
						padding: 0 20px;
						font-size: 14px;
						font-weight: 600;
						background: rgba(255, 255, 255, 0.2);
						border: 1px solid rgba(255, 255, 255, 0.3);
						color: white;
						border-radius: 8px;
						transition: all 0.3s ease;
						backdrop-filter: blur(10px);

						&:hover {
							background: rgba(255, 255, 255, 0.3);
							transform: translateY(-1px);
							box-shadow: 0 4px 12px rgba(255, 255, 255, 0.2);
						}
					}
				}

				.pc-home-editor-body {
					flex: 1;
					display: flex;
					flex-direction: column;
					min-height: 0;
					overflow: hidden;
					position: relative;
				}

				.pc-home-editor-content-wrapper {
					flex: 1;
					overflow: hidden;
					display: flex;
					flex-direction: column;
					min-height: 0;
				}

				.pc-home-editor-content {
					flex: 1;
					overflow-y: auto;
					padding: 24px;
					min-height: 0;
					position: relative;
					z-index: 2;

					.pc-home-module-list {
						display: grid;
						gap: 16px;

						.pc-home-module-item {
							padding: 20px;
							background: #ffffff;
							border: 2px dashed rgba(91, 140, 255, 0.3);
							border-radius: 12px;
							display: flex;
							align-items: center;
							gap: 16px;
							cursor: pointer;
							transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
							position: relative;
							overflow: hidden;

							&::before {
								content: '';
								position: absolute;
								top: 0;
								left: -100%;
								width: 100%;
								height: 100%;
								background: linear-gradient(90deg, transparent, rgba(91, 140, 255, 0.1), transparent);
								transition: left 0.6s;
							}

							&:hover {
								border-color: #5B8CFF;
								background: #5B8CFF;
								transform: translateY(-3px);
								box-shadow: 0 8px 25px rgba(91, 140, 255, 0.2);

								&::before {
									left: 100%;
								}

								.pc-home-module-icon i,
								.pc-home-module-name {
									color: white;
								}
							}

							.pc-home-module-icon {
								width: 40px;
								height: 40px;
								display: flex;
								align-items: center;
								justify-content: center;
								background: rgba(91, 140, 255, 0.1);
								border-radius: 10px;
								transition: all 0.3s ease;

								i {
									font-size: 20px;
									color: #5B8CFF;
									transition: color 0.3s ease;
								}
							}

							.pc-home-module-name {
								font-size: 16px;
								font-weight: 600;
								color: #303133;
								transition: color 0.3s ease;
							}
						}
					}

					.pc-home-item-list {
						.pc-home-current-module {
							display: flex;
							justify-content: space-between;
							align-items: center;
							margin-bottom: 24px;
							padding-bottom: 16px;
							border-bottom: 1px solid rgba(91, 140, 255, 0.1);

							.pc-home-module-info {
								display: flex;
								align-items: center;
								gap: 8px;

								i {
									color: #5B8CFF;
									font-size: 18px;
								}

								span {
									font-weight: 600;
									color: #303133;
									font-size: 16px;
								}
							}

							.pc-home-back-btn {
								border-color: #5B8CFF;
								color: #5B8CFF;
								font-weight: 500;
								
								&:hover {
									background: #5B8CFF;
									color: white;
									transform: translateX(-2px);
								}
							}
						}

						.pc-home-item {
							margin-bottom: 24px;
							background: #ffffff;
							border: 1px solid rgba(91, 140, 255, 0.2);
							border-radius: 12px;
							overflow: hidden;
							transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
							position: relative;
							z-index: 1;

							&::before {
								content: '';
								position: absolute;
								top: 0;
								left: 0;
								right: 0;
								height: 3px;
								background: #5B8CFF;
							}

							&:hover {
								box-shadow: 0 8px 32px rgba(91, 140, 255, 0.15);
								transform: translateY(-2px);
							}

							.pc-home-item-header {
								background: rgba(91, 140, 255, 0.05);
								padding: 16px 20px;
								display: flex;
								justify-content: space-between;
								align-items: center;
								border-bottom: 1px solid rgba(91, 140, 255, 0.1);
								position: relative;
								z-index: 1;

								.pc-home-item-index {
									font-size: 14px;
									font-weight: 600;
									color: #5B8CFF;
									background: rgba(91, 140, 255, 0.1);
									padding: 6px 12px;
									border-radius: 6px;
									border: 1px solid rgba(91, 140, 255, 0.2);
									display: flex;
									align-items: center;
									gap: 6px;
								}

								.pc-home-item-actions {
									display: flex;
									gap: 8px;
									position: relative;
									z-index: 10;

									::v-deep .el-button {
										padding: 6px 8px;
										transition: all 0.3s ease;
										border-radius: 6px;
										position: relative;
										z-index: 11;

										&:hover {
											transform: scale(1.1);
											box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
										}
										
										&:disabled {
											opacity: 0.5;
											cursor: not-allowed;
											
											&:hover {
												transform: none;
												box-shadow: none;
											}
										}
									}
								}
							}

							.pc-home-item-content {
								padding: 20px;
								position: relative;
								z-index: 1;

								.pc-home-item-image {
									margin-bottom: 20px;

									.pc-home-image-label {
										font-size: 14px;
										color: #303133;
										margin-bottom: 12px;
										font-weight: 600;
										display: flex;
										align-items: center;
										gap: 6px;
									}
								}

								.pc-home-item-form {
									::v-deep .el-form-item {
										margin-bottom: 20px;

										&:last-child {
											margin-bottom: 0;
										}

										.el-form-item__label {
											font-size: 14px;
											color: #303133;
											font-weight: 600;
										}

										.el-input__inner {
											border-radius: 8px;
											border: 1px solid rgba(91, 140, 255, 0.3);
											transition: all 0.3s ease;

											&:focus {
												border-color: #5B8CFF;
												box-shadow: 0 0 0 2px rgba(91, 140, 255, 0.1);
											}
										}
									}
								}
							}
						}
					}
				}

				.pc-home-editor-footer {
					padding: 20px;
					border-top: 1px solid rgba(91, 140, 255, 0.1);
					flex-shrink: 0;
					background: white;
					position: relative;
					z-index: 10;

					.pc-home-add-btn {
						width: 100%;
						padding: 14px;
						border: 2px dashed #5B8CFF;
						border-radius: 10px;
						display: flex;
						align-items: center;
						justify-content: center;
						gap: 10px;
						color: #5B8CFF;
						cursor: pointer;
						transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
						background: rgba(91, 140, 255, 0.05);
						font-weight: 600;
						font-size: 14px;
						position: relative;
						z-index: 11;

						&:hover {
							background: #5B8CFF;
							color: white;
							border-color: #5B8CFF;
							transform: translateY(-2px);
							box-shadow: 0 6px 20px rgba(91, 140, 255, 0.3);
						}
					}
				}
			}
		}
	}
}

/* 空状态样式 */
.pc-home-empty-banner,
.pc-home-empty-classify,
.pc-home-empty-cooperation,
.pc-home-empty-image {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 40px;
	color: #909399;
	border: 2px dashed #e0e0e0;
	border-radius: 8px;
	background: #fafafa;
	
	i {
		font-size: 48px;
		margin-bottom: 16px;
		color: #c0c4cc;
	}
	
	div {
		font-size: 14px;
	}
}

.pc-home-empty-image {
	width: 300px;
	height: 180px;
}

.pc-home-empty-banner {
	height: 200px;
}

.pc-home-empty-classify {
	width: 100%;
	padding: 60px;
}

.pc-home-empty-cooperation {
	width: 100%;
	padding: 40px;
}

/* 响应式适配 */
@media (max-width: 1440px) {
	.pc-home-page .pc-home-page-wrapper .pc-home-page {
		padding: 20px;
		gap: 20px;

		.pc-home-editor-panel {
			width: 380px;
		}
	}
}

@media (max-width: 1200px) {
	.pc-home-page .pc-home-page-wrapper {
		height: auto;
		min-height: 100vh;

		.pc-home-page {
			flex-direction: column !important;
			height: auto;
			min-height: 100vh;

			.pc-home-content {
				order: 2;
				flex: none;
				min-height: 500px;
			}

			.pc-home-editor-panel {
				order: 1;
				width: 100%;
				margin-bottom: 20px;
				flex: none;
				min-height: 500px;
				
				// 确保移动端按钮可点击
				.pc-home-editor-content {
					.pc-home-item {
						.pc-home-item-header {
							.pc-home-item-actions {
								::v-deep .el-button {
									// 在移动端增加按钮点击区域
									padding: 8px 10px;
									min-width: 36px;
									min-height: 36px;
									
									.el-icon-top,
									.el-icon-bottom,
									.el-icon-delete {
										font-size: 14px;
									}
								}
							}
						}
					}
				}
			}
		}
	}
}

/* 针对笔记本屏幕的优化 */
@media (max-width: 1366px) {
	.pc-home-page .pc-home-page-wrapper .pc-home-page .pc-home-content {
		padding: 24px;
		
		.pc-home-classify {
			padding: 36px 10%;
			
			.pc-home-classify-title {
				font-size: 18px;
			}
			
			.pc-home-classify-label {
				font-size: 12px;
			}
			
			.pc-home-classify-list {
				gap: 8px;
				margin-top: 20px;
				
				.pc-home-classify-item {
					padding: 8px 12px;
					width: calc(25% - 8px);
					border-radius: 8px;
					
					.pc-home-classify-icon {
						width: 16px;
						height: 16px;
					}
					
					.pc-home-classify-name {
						font-size: 10px;
						max-width: 70px;
					}
					
					.pc-home-classify-item-more {
						width: 16px;
						height: 16px;
						
						i {
							font-size: 9px;
						}
					}
				}
			}
		}
		
		.pc-home-about {
			padding: 30px 40px 20px;
			
			.pc-home-about-info {
				gap: 24px;
				max-height: 320px;
				
				.pc-home-about-image {
					width: 280px;
					
					::v-deep .el-image {
						height: 160px;
					}
				}
				
				.pc-home-about-content {
					.pc-home-about-info-title {
						font-size: 15px;
					}
					
					.pc-home-about-info-content {
						font-size: 12px;
						max-height: 120px;
					}
				}
			}
		}
		
		.pc-home-cooperation {
			padding: 30px 10%;
			
			.pc-home-cooperation-title {
				font-size: 18px;
			}
			
			.pc-home-cooperation-label {
				font-size: 12px;
			}
			
			.pc-home-cooperation-list {
				gap: 12px;
				margin-top: 20px;
				
				.pc-home-cooperation-item {
					padding: 14px;
					width: calc(25% - 9px);
					
					::v-deep .el-image {
						height: 45px;
					}
				}
			}
		}
	}
}

/* 全局重置 */
.pc-home-page * {
	box-sizing: border-box;
}

/* 确保按钮不被其他元素遮挡 */
::v-deep .el-tooltip__popper {
	z-index: 9999 !important;
}
</style>